<template>
  <span v-html="html"></span>
</template>

<script>
import { diffWords, diffArrays } from 'diff'
import { diffWordsArray } from '@/utils/string'

export default {
  props: {
    answer: {
      type: String | Array,
      default: ''
    },
    myAnswer: {}
    ,
    content: {
      type: String | Array,
      default: ''
    },
    type: {
      type: String,
      default: 'word' // word, array, moreWord
    },
    splitStr: {
      type: String,
      default: ', '
    }
  },
  // 在 methods 中添加
  methods: {
    // 分词：保留连字符单词、空格、其他标点
    tokenizeWithHyphens(str) {
      if (typeof str !== 'string') return [];
      return str.match(/[\w\-]+|\s+|[^\w\s]/g) || [];
    },

    renderWordDiff() {
      const answerTokens = this.tokenizeWithHyphens(this.answer);
      const userTokens = this.tokenizeWithHyphens(this.content);
      const diff = diffArrays(answerTokens, userTokens);

      return diff.map(item => {
        if (item.removed) {
          // 缺失部分：红色括号
          const value = item.value.join('');
          return `<i style="color: #FF606D;">(${value})</i>`;
        }
        if (item.added) {
          // 多余部分：每个非空格 token 加红色删除线，空格原样保留
          return item.value.map(token => {
            if (/^\s+$/.test(token)) return token; // 空格直接返回
            return `<i style="color: #FF606D; text-decoration: line-through;">${token}</i>`;
          }).join('');
        }
        // 相同部分：绿色（空格不加色）
        const value = item.value.join('');
        if (/^\s+$/.test(value)) return value;
        return `<i style="color: #36C626;">${value}</i>`;
      }).join('');
    }
  },
  computed: {
    html() {
      if (this.type === 'word') {
        // return diffWords(this.answer, this.content)
        //   .map((item) => {
        //     if (item.removed) {
        //       return `<i style="color: #FF606D;">(${item.value})</i>`
        //     }
        //     if (item.added) {
        //       let color = '#FF606D'
        //       const words = item.value.split(/(\s+)/)
        //       let isMatch = false
        //       return words.map(word => {
        //         const matchingItem = this.myAnswer.find(item => 
        //           item.text === word && item.color === 'green'
        //         );
        //         if (matchingItem) {
        //           isMatch = true
        //         }
        //         let color = isMatch ? '#36C626' : '#FF606D';
        //         return `<i style="color: ${color};text-decoration:line-through;">${word}</i>`;
        //       }).join(' ');
        //       // return `<i style="color: ${color};text-decoration:line-through;">${item.value}</i>`
        //     }
        //     return `<i style="color: #36C626">${item.value}</i>`
        //   })
        //   .join('')
        return this.renderWordDiff();
      } else if (this.type === 'array') {
        return diffArrays(this.answer, this.content)
          .map((item) => {
            if (item.removed) {
              return `<i style="color: #FF606D;">${item.value
                .map((m) => `(${m})`)
                .join(this.splitStr)}</i>`
            }
            if (item.added) {
              return `<i style="color: #FF606D;text-decoration:line-through;">${item.value.join(
                this.splitStr
              )}</i>`
            }
            return `<i style="color: #36C626">${item.value.join(
              this.splitStr
            )}</i>`
          })
          .join(this.splitStr)
      } else if (this.type === 'moreWord') {
        console.log(this.answer, this.content)
        return diffWordsArray(this.answer, this.content)
          .map((item) => {
            if (item.removed) {
              return `<i style="color: #FF606D;">(${item.value})</i>`
            }
            if (item.added) {
              return `<i style="color: #9C9C9C;">${item.value}</i>`
            }
            return `<i style="color: #36C626">${item.value}</i>`
          })
          .join(' ')
      }
    }
  }
}
</script>

<style scoped></style>
